<template>
  <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Group-2" transform="translate(5.000000, 30.000000)" stroke="#3F3F3F" stroke-width="1.34000003">
      <polygon id="Stroke-181" points="20.57 23.0535593 64.8813333 23.0535593 64.8813333 16.5166102 20.57 16.5166102"></polygon>
      <polygon id="Stroke-182" points="13.7133333 39.5708475 20.57 39.5708475 20.57 0 13.7133333 0"></polygon>
      <polygon id="Stroke-183" points="6.85666667 32.9464407 13.7133333 32.9464407 13.7133333 6.62372881 6.85666667 6.62372881"></polygon>
      <polygon id="Stroke-185" points="64.8813333 39.5708475 71.738 39.5708475 71.738 0 64.8813333 0"></polygon>
      <polygon id="Stroke-186" points="71.738 32.9464407 78.5946667 32.9464407 78.5946667 6.62372881 71.738 6.62372881"></polygon>
      <polygon id="Stroke-184" points="0 26.3410169 6.85666667 26.3410169 6.85666667 13.2291525 0 13.2291525"></polygon>
      <polygon id="Stroke-187" points="78.5946667 26.3410169 85.4513333 26.3410169 85.4513333 13.2291525 78.5946667 13.2291525"></polygon>
    </g>
</g>
</template>